import { Watermark } from 'roosterjs-editor-plugins/lib/Watermark';
import { DefaultFormat } from 'roosterjs-editor-types';
import { DefaultPalette } from '@uifabric/styling/lib';

const DEFAULT_FONT_FAMILY: string =
    '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif';
const DEFAULT_FONT_SIZE: string = '14px';
const DEFAULT_TEXT_COLOR_LIGHT: string = DefaultPalette.neutralSecondary;
const DEFAULT_TEXT_COLOR_DARK: string = DefaultPalette.neutralTertiary;

const DEFAULT_FORMAT: DefaultFormat = {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSize: DEFAULT_FONT_SIZE,
    textColor: DEFAULT_TEXT_COLOR_LIGHT,
    textColors: {
        lightModeColor: DEFAULT_TEXT_COLOR_LIGHT,
        darkModeColor: DEFAULT_TEXT_COLOR_DARK,
    },
};

export default class OwaWatermark extends Watermark {
    constructor(watermark: string, format?: DefaultFormat) {
        super(watermark, format || DEFAULT_FORMAT);
    }
}
